import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { useRecoilState } from "recoil";
import {
  inspStatusReportFilterState,
  selectedMenuState,
} from "../../recoil/index.ts";
import { useNavigate } from "react-router-dom";
import {
  ArrowUpwardIcon,
  FilterAltOutlinedIcon,
  DownloadOutlinedIcon,
  ArrowBackIcon,
  CheckIcon,
  CachedIcon,
} from "../../icons/index.tsx";
import {
  Box,
  IconButton,
  Button,
  Select,
  MenuItem,
  Typography,
  Pagination,
  CircularProgress,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  getClientIp,
  getAviOIData,
  getDataByDate,
  getUnitInfo,
  getLatestData,
  getGroupCountStream,
  getUnitDataStream,
  getCSVData,
  getAviOIDataStream,
  getDieCount,
  getUnitCountStream,
} from "../../services/inspectStatReportService.js";
import { t } from "i18next";
import { getInspStatusImage } from "../../services/inspectService.js";
import { filterModalStyle } from "../../utils/styleUtils.js";
// import CrossTable from "components/report/CrossTable.js";
// import UnitInfoModal from "components/report/UnitInfoModal.js";
// import InspectionTypeRadio from "components/report/InspectionTypeRadio.js";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs/index.js";
import dayjs from "dayjs";
// import InspStatReportTable from "components/table/InspStatReportTable.js";
// import ReportGraph from "components/ReportGraph.js";
// import InspStatReportModal from "components/table/InspStatReportModal.js";
// import InspStatTopTable from "components/report/InspStatTopTable.js";
// import DateRangeSelector from "components/report/DateRangeSelector.js";
// import ReportFilterMenu from "components/report/ReportFilterMenu.js";
// import ReportDownloadMenu from "components/report/ReportDownloadMenu.js";
import { getSystemConfig } from "../../services/userService.ts";
import { filteringField } from "../../utils/reportUtils.js";
import { toast } from "react-toastify";
import InspStatTopTable from "./InspStatTopTable.js";
import DateRangeSelector from "./DateRangeSelector.js";
import ReportFilterMenu from "./ReportFilterMenu.js";
import ReportDownloadMenu from "./ReportDownloadMenu.js";
import InspStatReportTable from "./InspStatReportTable.js";
import ReportGraph from "./ReportGraph.js";
import InspStatReportModal from "./InspStatReportModal.js";
import InspectionTypeRadio from "./InspectionTypeRadio.js";
import CrossTable from "./CrossTable.js";
import UnitInfoModal from "./UnitInfoModal.js";

// 연속적인 요청 막기
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export const fieldOptions = {
  공지사항: ["id", "title", "content", "user_name", "update_at"],
  사용자: ["id", "user_id", "name", "authority", "is_admin", "approval_status"],
  "Data Set": ["id", "name", "total_labeled_files"],
  베이스모델: ["id", "name"],
  모델: ["id", "name"],
  검사규칙: ["id", "model_name", "recipe_regex", "image_regex"],
  검사현황: ["id", "client_ip", "name", "material_name", "label", "create_at"],
  학습: ["id", "name"],
  "시스템 로그": ["id", "level", "message", "timestamp"],
  "학습 로그": ["id", "create_at", "info", "train_uuid"],
};

export default function InspStatusReportPage() {
  const [selectedMenu, setSelectedMenu] = useRecoilState(selectedMenuState);
  const [receivedData, setReceivedData] = useState([]);
  const [totalDieCount, setTotalDieCount] = useState(0);
  const [reviewNgDieCount, setReviewNgDieCount] = useState(0);
  const [unitTotalCount, setUnitTotalCount] = useState(0);
  const [reviewNgUnitCount, setReviewNgUnitCount] = useState(0);
  const [ngUnitCount, setNgUnitCount] = useState(1); // inspectionType 기준 유닛 카운트
  const [filterOption, setFilterOption] = useRecoilState(
    inspStatusReportFilterState
  );
  const [columnResize, setColumnResize] = useState(() => {
    const savedColumnResize = localStorage.getItem("columnResize");
    return savedColumnResize ? JSON.parse(savedColumnResize) : {};
  });
  const [openUnitModal, setOpenUnitModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [imageUrls, setImageUrls] = useState({});
  const [selectedIp, setSelectedIp] = useState("ALL");
  const [clientIps, setClientIps] = useState([]);
  const [selectedLot, setSelectedLot] = useState("");
  const navigate = useNavigate();
  const [inspectionType, setInspectionType] = useState("AVI");
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [unitLastId, setUnitLastId] = useState(0);
  const [unitLastIdList, setUnitLastIdList] = useState([
    { page: 1, lastId: 0 },
  ]);

  // ====민준 ===
  const [openReportModal, setOpenReportModal] = useState(false);
  const [dateRange, setDateRange] = useState({
    start: null,
    end: null,
  });
  const [rateData, setRateData] = useState([]);
  const [totalRateData, setTotalRateData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [labelType, setLabelType] = useState("Day");
  const [selectDay, setSelectDay] = useState("");
  const [selectWeek, setSelectWeek] = useState("");
  const [selectMonth, setSelectMonth] = useState("");
  const [reset, setReset] = useState(false);
  const [inputMaterial, setInputMaterial] = useState("");
  const [generalData, setGeneralData] = useState([]);
  const [uuid, setUuid] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [debouncedMaterial, setDebouncedMaterial] = useState("");
  const [selectedImagePath, setSelectedImagePath] = useState(null);
  const [image, setImage] = useState(null);
  const [openDetailFilter, setOpenDetailFilter] = useState(false);
  const filterIconRef = useRef(null);
  const downloadMenuRef = useRef(null);
  const [selectAvi, setSelectAvi] = useState("");
  const [selectAi, setSelectAi] = useState("NG");
  const [selectHr, setSelectHr] = useState("");
  const [isFilter, setIsFilter] = useState(false);
  const [labelFilterOption, setLabelFilterOption] = useState({
    avi: "",
    ai: "NG",
    hr: "",
  });
  const [openDownloadMenu, setOpenDownloadMenu] = useState(false);
  const [reportPage, setReportPage] = useState(1);
  const [reportPageSize, setReportPageSize] = useState(20);
  const [reportTotalCount, setReportTotalCount] = useState(0);
  const [unitPage, setUnitPage] = useState(1);
  const [unitPageSize, setUnitPageSize] = useState(20);
  const [referenceAI, setReferenceAI] = useState("hr");
  const [referenceAVI, setReferenceAVI] = useState("ai");
  const [isLoading, setIsLoading] = useState(false);
  const [getDate, setGetDate] = useState(null);
  const [latestDate, setLatestDate] = useState(null);
  const [siteData, setSiteData] = useState(null);
  const [siteOption, setSiteOption] = useState(null);
  const [reportField, setReportField] = useState([]);
  const [selectField, setSelectField] = useState([]);

  const [isLoadingFetchStat, setIsLoadingFetchStat] = useState(false);
  const [isLoadingUnitSum, setIsLoadingUnitSum] = useState(false);
  // const siteOptions = require.context("../datas/siteOption", false, /\.json$/);

  // 개발용 get config
  useEffect(() => {
    let site_option;
    const fetchConfig = async () => {
      try {
        const response = await getSystemConfig();
        if (response.config) {
          site_option = response.config;
        }
        const res = await fetch(`/siteOption/${site_option}.json`);

        if (!res.ok) {
          throw new Error(`File not found: /siteOption/${site_option}.json`);
        }

        const data = await res.json();
        setSiteData(data);
        setSiteOption(site_option);
      } catch (error) {
        console.error("Error fetching configuration:", error);
      }
    };
    fetchConfig();
  }, []);

  // 최신 데이터 날짜 조회
  const fetchLatestData = async () => {
    const response = await getLatestData();
    const latestDate = response.latestRecord.create_at.split("T")[0];
    if (latestDate) {
      setDateRange({
        start: latestDate,
        end: latestDate,
      });
      setLatestDate(latestDate);
    }
  };

  useEffect(() => {
    fetchLatestData();
  }, [selectedIp]);

  //======= 민준 코드 끝 =======

  // DataGrid 헤더 클릭 이벤트

  // 컬럼 리사이즈 이벤트
  const handleColumnResize = (params) => {
    const { field, width } = params.colDef;
    setColumnResize((prev) => ({
      ...prev,
      [selectedMenu]: {
        ...prev[selectedMenu],
        [field]: width,
      },
    }));
  };

  // 로컬스토리지에 컬럼 리사이즈 저장
  const saveToLocalStorage = useCallback(
    debounce(async (resizeData) => {
      localStorage.setItem("columnResize", JSON.stringify(resizeData));
    }, 500),
    []
  );

  useEffect(() => {
    setSelectedMenu(t("InspStatusReport"));
    fetchIPData();
  }, []);

  // useEffect정리
  useEffect(() => {
    if (siteOption && siteOption !== "FUREX") {
      fetchTotalCount();
    }
  }, [siteOption, filterOption, dateRange]);

  useEffect(() => {
    setUnitPage(1);
    setUnitLastId(0);
    setUnitLastIdList([{ page: 1, lastId: 0 }]);
    setSelectedLot("");
    setSelectedRow(null);
    let cleanup;

    const fetch = async () => {
      cleanup = await fetchUnitData();
    };

    fetch();

    return () => {
      if (cleanup) {
        cleanup();
      }
    };
  }, [inspectionType, filterOption, dateRange]);

  useEffect(() => {
    setSelectedRow(null);
  }, [unitPage]);

  // 컬럼 리사이즈 저장
  useEffect(() => {
    saveToLocalStorage(columnResize);
  }, [columnResize]);

  // 컬럼 너비 계산
  const getColumnWidth = (field, defaultWidth) => {
    return (
      (columnResize[selectedMenu] && columnResize[selectedMenu][field]) ||
      defaultWidth
    );
  };

  // 컬럼 데이터 설정 - unit 단위 테이블
  const unitColumns = useMemo(
    () => [
      { field: "id", headerName: "ID", width: 90 },
      {
        field: "location",
        headerName: "Location (x,y)",
        width: 130,
      },
      { field: "lot", headerName: "Lot", width: 200 },
      { field: "zone", headerName: "Zone", width: 130 },
      {
        field: "image_count",
        headerName: "NG Die Image Count",
        width: 200,
        renderCell: (params) => {
          return `${params.value}장`;
        },
      },
    ],
    [inspectionType]
  );

  const selectedFields = fieldOptions[selectedMenu];

  useEffect(() => {
    setUnitLastId(0);
    setUnitLastIdList([{ page: 1, lastId: 0 }]);
  }, [inspectionType]);

  const [allUnits, setAllUnits] = useState([]);
  const [cachedData, setCachedData] = useState({});
  const [totalPage, setTotalPage] = useState(0);

  const fetchUnitData = async () => {
    if (dateRange.start && dateRange.end) {
      setIsLoading(true);
      setCachedData({}); // 새로운 데이터 요청 시 캐시 초기화

      const cleanup = getUnitDataStream({
        params: {
          ...filterOption,
          start_date: dateRange.start,
          end_date: dateRange.end,
          type: inspectionType,
          pageSize: unitPageSize,
        },
        onMessage: (data) => {
          if (data.error) {
            console.error("Error:", data.error);
            return;
          }
          // 받은 데이터를 캐시에 저장
          setTotalPage(data.page);
          setCachedData((prev) => ({
            ...prev,
            [data.page]: data.units,
          }));

          // 현재 페이지의 데이터면 바로 표시
          if (data.page === unitPage) {
            setReceivedData(data.units);
          }

          if (data.isComplete) {
            setIsLoading(false);
            setTotalPage(data.totalPage);
            setTotalPage(data.totalPages);
          }
        },
        onError: (error) => {
          console.error("Error:", error);
          setIsLoading(false);
        },
      });

      return cleanup;
    }
  };

  useEffect(() => {
    if (cachedData[unitPage]) {
      setReceivedData(cachedData[unitPage]);
    }
  }, [unitPage, cachedData]);

  const fetchTotalCount = () => {
    if (dateRange.start && dateRange.end) {
      // dieCount 먼저 요청
      getDieCount({
        ...filterOption,
        start_date: dateRange.start,
        end_date: dateRange.end,
      })
        .then((dieResponse) => {
          setTotalDieCount(dieResponse.data.total_die_count);
          setReviewNgDieCount(dieResponse.data.review_ng_die_count);
        })
        .catch((error) => {
          console.error("Error fetching die count:", error);
        });
      sumUnitCount();
    }
  };

  const sumUnitCount = () => {
    let total = 0;
    let reviewNG = 0;
    setIsLoadingUnitSum(true);
    const stopStream = getUnitCountStream({
      params: {
        ...filterOption,
        start_date: dateRange.start,
        end_date: dateRange.end,
      },
      onMessage: (data) => {
        total += data.total_unit_count || 0;
        reviewNG += data.review_ng_unit_count || 0;
        setUnitTotalCount(total);
        setReviewNgUnitCount(reviewNG);
        setIsLoadingUnitSum(true);
      },
      onError: (err) => {
        console.error("SSE error:", err);
      },
      onComplete: () => {
        setIsLoadingUnitSum(false);

        console.log("✅ SSE complete");
      },
    });

    return () => {
      stopStream(); // 컴포넌트 unmount 시 종료
    };
  };

  const [count, setCount] = useState(0);
  const fetchGroupCount = async () => {
    setIsLoading(true);

    if (dateRange.start && dateRange.end) {
      const cleanup = getGroupCountStream({
        params: {
          start_date: dateRange.start,
          end_date: dateRange.end,
          type: inspectionType,
        },
        onMessage: (count) => {
          setCount(count);
        },
        onError: (error) => {
          console.error("Error fetching count:", error);
          setIsLoading(false);
        },
        onComplete: () => {
          setIsLoading(false);
        },
      });

      return cleanup;
    }
  };

  const fetchIPData = async () => {
    try {
      const response = await getClientIp();
      setClientIps(response.clientIps);
    } catch (error) {
      console.error("Error fetching client IPs:", error);
    }
  };

  // unit 단위 테이블 row Click
  const onRowClick = async (params) => {
    try {
      const rowData = params.row;
      setSelectedLot(rowData.lot);
      setSelectedRow({ ...rowData, label: "NG" });
      if (rowData.lot === selectedLot) {
        setSelectedUnit(null);
        // const unitInfo = await getUnitInfo(rowData.ids);
        const idsArray = rowData.ids
          .split(",")
          .map((id) => parseInt(id.trim()));
        const unitInfo = await getUnitInfo(idsArray);
        setOpenUnitModal(true);
        setSelectedUnit(unitInfo.data);
      }
    } catch (error) {
      console.error("Error fetching unit info:", error);
    }
  };

  // pagination change
  const onChangePage = (newPage) => {
    const pageData = Object.values(unitLastIdList).find(
      (item) => item.page === newPage
    );
    if (pageData) {
      setUnitLastId(pageData.lastId);
      setUnitPage(newPage);
    } else {
      setUnitPage(newPage);
    }
  };

  // IP 선택 시 필터링 설정 ✅
  const handleSelectedIpChange = (e) => {
    setSelectedIp(e.target.value);

    if (e.target.value === "ALL") {
      setFilterOption({
        ...filterOption,
        client_ip: null,
      });
    } else {
      setFilterOption({
        ...filterOption,
        client_ip: e.target.value,
      });
    }
  };

  // ======= 민준 코드 =======
  const generalColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "name", headerName: "파일명", width: 150 },
    { field: "lot", headerName: "Lot", width: 130 },
    { field: "material_name", headerName: "Material", width: 130 },
    { field: "avi", headerName: "AVI", width: 100 },
    { field: "label", headerName: "AI", width: 100 },
    { field: "review", headerName: "HR", width: 130 },
    { field: "zone", headerName: "Cell", width: 80 },
    {
      field: "location",
      headerName: "Location",
      width: 130,
      renderCell: (params) => {
        const { x, y } = params.row;
        return `(${x},${y})`;
      },
    },
    {
      field: "create_at",
      headerName: "Create At",
      width: 180,
      renderCell: (params) => {
        if (!params.value) return "-";
        const [date, time] = params.value.split("T");
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div>
              {date} {time.split(".")[0]}
            </div>
          </div>
        );
      },
    },
  ];

  // 데이터 변환 함수
  const transformGeneralData = (data) => {
    return data.map((item) => ({
      ...item,
      avi:
        item.review !== "undefined" &&
        item.review !== null &&
        item.review !== ""
          ? "NG"
          : "OK",
      hr:
        item.review !== "undefined" &&
        item.review !== null &&
        item.review !== ""
          ? "OK"
          : item.review,
      original_review: item.review,
    }));
  };

  // 날짜 범위 설정
  useEffect(() => {
    if (selectDay !== "" || selectWeek !== "" || selectMonth !== "") {
      const today = dayjs(dateRange.end);
      let amount, unit;

      if (selectDay !== "") {
        [amount, unit] = selectDay.split(" ");
      } else if (selectWeek !== "") {
        [amount, unit] = selectWeek.split(" ");
      } else if (selectMonth !== "") {
        [amount, unit] = selectMonth.split(" ");
      }

      let startDate;
      switch (unit) {
        case "DAY":
          startDate = today.subtract(parseInt(amount), "day");
          break;
        case "WEEK":
          startDate = today.subtract(parseInt(amount), "week");
          break;
        case "MONTH":
          startDate = today.subtract(parseInt(amount), "month");
          break;
        default:
          return;
      }

      setDateRange({
        start: startDate.format("YYYY-MM-DD"),
        end: today.format("YYYY-MM-DD"),
      });
    }
  }, [selectDay, selectWeek, selectMonth, reset]);

  // 페이지네이션 관련 데이터만 가져오는 useEffect
  useEffect(() => {
    const fetchPageData = async () => {
      if (selectedIp && dateRange.start && dateRange.end) {
        let ip = selectedIp === "ALL" ? null : selectedIp;
        try {
          const dataByIp = await getDataByDate({
            client_ip: ip,
            start_date: dateRange.start,
            end_date: dateRange.end,
            material_name: debouncedMaterial || undefined,
            filter: labelFilterOption,
            page: reportPage,
            pageSize: reportPageSize,
          });
          const transformedData = transformGeneralData(dataByIp.data);
          setReportTotalCount(dataByIp.totalCount);
          setGeneralData(transformedData);
        } catch (error) {
          console.error("Error fetching page data:", error);
        }
      }
    };
    fetchPageData();
  }, [
    selectedIp,
    dateRange,
    debouncedMaterial,
    labelFilterOption,
    reportPage,
    reportPageSize,
  ]);

  // 통계 데이터를 가져오는 useEffect
  useEffect(() => {
    let isSubscribed = true;
    const controller = new AbortController();
    if (!siteOption) return;

    const fetchStatData = async () => {
      if (selectedIp && dateRange.start && dateRange.end) {
        let ip = selectedIp === "ALL" ? null : selectedIp;
        if (isSubscribed) {
          setIsLoading(true);
        }

        try {
          setIsLoadingFetchStat(true);
          let newRateData = [];

          // 날짜 범위 계산
          const startDate = dayjs(dateRange.start);
          const endDate = dayjs(dateRange.end);
          const daysDiff = endDate.diff(startDate, "day") + 1;

          // 각 날짜별로 API 요청
          for (let i = 0; i < daysDiff; i++) {
            if (!isSubscribed || controller.signal.aborted) {
              return;
            }
            const currentDate = startDate.add(i, "day").format("YYYY-MM-DD");
            const aviOIdataStream = getAviOIDataStream({
              client_ip: ip,
              start_date: currentDate,
              end_date: currentDate,
              material_name: debouncedMaterial || undefined,
              referenceAI: referenceAI,
              referenceAVI: referenceAVI,
              // signal: controller.signal,
            });
            // 한 날짜에 대한 전체 데이터 조회
            const aviOIdata = await getAviOIData(
              {
                client_ip: ip,
                start_date: currentDate,
                end_date: currentDate,
                material_name: debouncedMaterial || undefined,
                referenceAI: referenceAI,
                referenceAVI: referenceAVI,
                site: siteOption,
              },
              controller.signal
            );

            if (!isSubscribed || controller.signal.aborted) {
              return;
            }
            setGetDate(aviOIdata.newData[0].date);
            newRateData = [...newRateData, ...aviOIdata.newData];
            setRateData(newRateData);
          }
        } catch (error) {
          console.error("Error fetching stat data:", error);
        } finally {
          if (isSubscribed) {
            setIsLoading(false);

            setIsLoadingFetchStat(false);
          }
        }
      }
    };
    fetchStatData();

    return () => {
      isSubscribed = false;
      controller.abort();
    };
  }, [
    selectedIp,
    dateRange,
    debouncedMaterial,
    referenceAI,
    referenceAVI,
    siteOption,
  ]);

  const day = [1, 2, 3, 4, 5, 6];
  const week = [1, 2, 3, 4];
  const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const handleApplyFilter = () => {
    if (selectAvi === "" && selectAi === "" && selectHr === "") {
      setIsFilter(false);
    } else {
      // console.log(selectAvi, selectAi, selectHr);
      setLabelFilterOption({
        avi: selectAvi,
        ai: selectAi,
        hr: selectHr,
      });
      setIsFilter(true);
      setDebouncedMaterial(inputMaterial);
    }
  };

  const handleDownloadImage = async () => {
    for (const data of generalData) {
      try {
        const imageUrl = await getInspStatusImage(data.path); // 각 객체에 이미지 경로가 있다고 가정
        const fileName = data.name.split("/").pop(); // 파일 이름 추출
        const link = document.createElement("a");
        link.href = imageUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("이미지 다운로드 실패:", error);
      }
    }
  };

  const handleDownloadCsv = async (field) => {
    const filteredField = filteringField(field);
    const params = {
      start_date: dateRange.start,
      end_date: dateRange.end,
      fields: filteredField,
    };
    try {
      toast.success("CSV 다운로드가 시작되었습니다.");
      const response = await getCSVData(params);
      if (!response || response.status >= 400) {
        // 또는 별도 에러 핸들링 로직
        throw new Error(response?.message || "다운로드 실패");
      }

      const blob = response;
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const todayDate = new Date().toISOString().split("T")[0];
      link.href = url;
      link.setAttribute("download", `insp_report_${todayDate}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("CSV 다운로드 실패:", error);
    }
  };
  // ======= 민준 코드 끝 =======

  return (
    <Box sx={{ padding: 3, color: "var(--text-color)" }}>
      <Button variant="text" onClick={() => navigate("/insp_status")}>
        <ArrowBackIcon /> {t("BackToPath")}
      </Button>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <h1>검사 상태 리포트</h1>

          {getDate ? (
            <Typography
              variant="body1"
              color="var(--text-color)"
              sx={{ display: "flex", aliginItems: "center" }}
            >
              {dateRange.start} ~ {getDate}{" "}
              {isLoadingFetchStat || isLoadingUnitSum ? (
                <CircularProgress size={15} />
              ) : (
                <CheckIcon sx={{ color: "#2ec023ff" }} />
              )}
            </Typography>
          ) : (
            <Typography variant="body1" color="var(--text-color)">
              {" "}
            </Typography>
          )}
        </Box>
      </Box>
      {siteData && siteData.statistics.enable && (
        <InspStatTopTable
          unitCount={unitTotalCount}
          reviewNgUnitCount={reviewNgUnitCount}
          totalDieCount={totalDieCount}
          reviewNgDieCount={reviewNgDieCount}
          totalRateData={totalRateData}
          referenceAI={referenceAI}
          setReferenceAI={setReferenceAI}
          referenceAVI={referenceAVI}
          setReferenceAVI={setReferenceAVI}
          rateData={rateData}
          site_option={siteOption}
          siteData={siteData}
        />
      )}

      {/* ) : (
        <Typography variant="body1" color="text.secondary">
          데이터를 불러오는 중입니다...
        </Typography>
      )}{" "}
      */}
      {siteData && siteData.tableField.enable && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: `1px solid var(--border-line-color)`,
            borderBottom: "none",
            justifyContent: "space-between",
            overflow: "hidden",
            overflowX: "auto",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", p: 1 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                p: 1,
                borderRight: "1px solid var(--border-line-color)",
                width: "80%",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateRangeSelector
                  selectDay={selectDay}
                  setSelectDay={setSelectDay}
                  selectWeek={selectWeek}
                  setSelectWeek={setSelectWeek}
                  selectMonth={selectMonth}
                  setSelectMonth={setSelectMonth}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  day={day}
                  week={week}
                  month={month}
                />
                <IconButton
                  onClick={() => {
                    setDateRange({ start: latestDate, end: latestDate });
                    setSelectDay("");
                    setSelectWeek("");
                    setSelectMonth("");
                    setInputMaterial("");
                    setReset(true);
                    setFilterOption({
                      ...filterOption,
                      client_ip: null,
                      material_name: null,
                    });
                    setLabelFilterOption({
                      avi: "",
                      ai: "",
                      hr: "",
                    });
                    setSelectAvi("");
                    setSelectAi("");
                    setSelectHr("");
                  }}
                  title="필터 초기화"
                >
                  <CachedIcon sx={{ color: "var(--text-color)" }} />
                </IconButton>
              </LocalizationProvider>
            </Box>
            <Box>
              <Box
                sx={{
                  ml: 2,
                  display: "flex",
                  height: "56px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="var(--button-color)"
                  title="상세필터"
                  sx={{
                    minWidth: "40px",
                    height: "40px",
                    padding: "8px",
                  }}
                >
                  <FilterAltOutlinedIcon
                    ref={filterIconRef}
                    sx={{
                      fontSize: "30px",
                    }}
                    onClick={() => setOpenDetailFilter((prev) => !prev)}
                  />
                </Button>
                <Button
                  variant="var(--button-color)"
                  sx={{
                    ml: 1,
                    minWidth: "40px",
                    height: "40px",
                    padding: "8px",
                  }}
                  title="다운로드"
                >
                  <DownloadOutlinedIcon
                    ref={downloadMenuRef}
                    sx={{
                      fontSize: "30px",
                      // color: "var(--button-color)",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenDownloadMenu(true);
                    }}
                  />
                </Button>
                {/* 필터 메뉴 */}
                <ReportFilterMenu
                  openDetailFilter={openDetailFilter}
                  setOpenDetailFilter={setOpenDetailFilter}
                  filterIconRef={filterIconRef}
                  selectedIp={selectedIp}
                  handleSelectedIpChange={handleSelectedIpChange}
                  clientIps={clientIps}
                  inputMaterial={inputMaterial}
                  setInputMaterial={setInputMaterial}
                  selectAvi={selectAvi}
                  selectAi={selectAi}
                  selectHr={selectHr}
                  setSelectAvi={setSelectAvi}
                  setSelectAi={setSelectAi}
                  setSelectHr={setSelectHr}
                  handleApplyFilter={handleApplyFilter}
                  setIsFilter={setIsFilter}
                  filterModalStyle={filterModalStyle}
                  siteData={siteData}
                />
                {/* 다운로드 메뉴 */}
                <ReportDownloadMenu
                  openDownloadMenu={openDownloadMenu}
                  setOpenDownloadMenu={setOpenDownloadMenu}
                  downloadMenuRef={downloadMenuRef}
                  handleDownloadImage={handleDownloadImage}
                  handleDownloadCsv={handleDownloadCsv}
                  reportField={reportField}
                  selectField={selectField}
                  setSelectField={setSelectField}
                />

                <Select
                  value={reportPageSize}
                  onChange={(event) => {
                    setReportPageSize(event.target.value);
                  }}
                  size="small"
                  sx={{
                    ml: 1,
                    height: "40px",
                    padding: "8px",
                    color: "var(--text-color)",
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        backgroundColor: "var(--bg-color)",
                        color: "var(--text-color)",
                        border: "1px solid var(--border-line-color)",
                      },
                    },
                  }}
                >
                  <MenuItem
                    value={10}
                    sx={{
                      "&:hover": {
                        bgcolor: "var(--hover-bg-color)",
                      },
                    }}
                  >
                    10개씩
                  </MenuItem>
                  <MenuItem
                    value={20}
                    sx={{
                      "&:hover": {
                        bgcolor: "var(--hover-bg-color)",
                      },
                    }}
                  >
                    20개씩
                  </MenuItem>
                  <MenuItem
                    value={50}
                    sx={{
                      "&:hover": {
                        bgcolor: "var(--hover-bg-color)",
                      },
                    }}
                  >
                    50개씩
                  </MenuItem>
                  <MenuItem
                    value={100}
                    sx={{
                      "&:hover": {
                        bgcolor: "var(--hover-bg-color)",
                      },
                    }}
                  >
                    100개씩
                  </MenuItem>
                </Select>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {siteData && siteData.tableField.enable && (
        <InspStatReportTable
          rows={generalData}
          columns={generalColumns}
          selectedFields={selectedFields}
          handleColumnResize={handleColumnResize}
          getColumnWidth={getColumnWidth}
          loading={loading}
          setUuid={setUuid}
          setOpenModal={setOpenReportModal}
          setSelectedData={setSelectedData}
          getRowId={(row) =>
            row.id || `${row.label}-${row.avi}-${row.create_at}`
          }
          page={reportPage}
          setPage={setReportPage}
          pageSize={reportPageSize}
          setPageSize={setReportPageSize}
          totalCount={reportTotalCount}
          siteData={siteData}
          reportField={reportField}
          setReportField={setReportField}
        />
      )}
      {siteData && siteData.graph.enable && (
        <ReportGraph
          rateData={rateData}
          labelType={labelType}
          setLabelType={setLabelType}
          siteData={siteData}
        />
      )}

      <InspStatReportModal
        openModal={openReportModal}
        setOpenModal={setOpenReportModal}
        selectedData={selectedData}
        image={image}
        selectedImagePath={selectedImagePath}
      />
      {siteData && siteData.unitTable.enable && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 2,
          }}
        >
          <InspectionTypeRadio
            value={inspectionType}
            onChange={(e) => setInspectionType(e.target.value)}
          />
        </Box>
      )}
      {siteData && siteData.unitTable.enable && (
        <>
          {selectedLot ? (
            <Box sx={{ mt: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                Lot: {selectedLot}
              </Typography>
              <CrossTable
                selectedLot={selectedLot}
                receivedData={receivedData}
              />
            </Box>
          ) : (
            <Box sx={{ mt: 2 }}>
              <Box
                sx={{
                  p: 4,
                  border: "1px dashed #ccc",
                  borderRadius: 1,
                  backgroundColor: "var(--paper-bg-color)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "200px",
                  gap: 2,
                }}
              >
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{
                    textAlign: "center",
                    fontWeight: "medium",
                    color: "var(--text-color)",
                  }}
                >
                  하단 테이블에서 Unit을 선택하면
                  <br />
                  해당 Lot의 상세 정보가 이 곳에 표시됩니다
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ opacity: 0.7, color: "var(--unselected-color)" }}
                >
                  클릭하여 원하는 Lot의 정보를 확인하세요
                </Typography>
              </Box>
            </Box>
          )}
        </>
      )}
      {siteData && siteData.unitTable.enable && (
        <Box sx={{ mt: 2 }}>
          <DataGrid
            // rows={receivedData.filter((row) => row.label === "NG")}
            rows={receivedData}
            columns={unitColumns.map((col, index) => ({
              ...col,
              width: getColumnWidth(col.field, col.width),
              resizable: index !== unitColumns.length - 1,
              renderHeader: (params) => (
                <div className="datagrid-head-container">
                  <span>{params.colDef.headerName}</span>
                  {selectedFields && selectedFields.includes(col.field) && (
                    <IconButton className="datagrid-sort-button">
                      <ArrowUpwardIcon sx={{ fontSize: "15px" }} />
                    </IconButton>
                  )}
                </div>
              ),
            }))}
            page={unitPage}
            setPage={setUnitPage}
            pageSize={unitPageSize}
            setPageSize={setUnitPageSize}
            totalCount={unitTotalCount}
            getRowClassName={(params) => {
              return params.row.id === selectedRow?.id ? "selected-row" : "";
            }}
            disableRowSelectionOnClick
            disableExtendRowFullWidth
            disableColumnSelectionOnClick
            disableColumnMenu
            disableColumnSorting
            hideFooter
            onRowClick={onRowClick}
            // onSortModelChange={handleSortClick}
            onColumnResize={handleColumnResize}
            sx={{
              border: "1px solid var(--dashboard-line-color) !important",
              height: "500px",
              "--DataGrid-rowBorderColor": "transparent",
              "--unstable_DataGrid-overlayBackground": "var(--td-color)",
              "& .MuiDataGrid-container--top [role='row'], & .MuiDataGrid-container--bottom [role='row']":
                {
                  background: "var(--th-color)",
                },
              "& .MuiDataGrid-root": {
                overflowX: "auto",
                "--DataGrid-rowBorderColor": "transparent",
              },
              "& .MuiContainer-root": {
                position: "fixed", //이렇게 하면 전체 부모에서 fixed됨..
              },
              "& .MuiDataGrid-virtualScroller": {
                // height: "fit-content"
              },
              "& .MuiDataGrid-scrollbar--vertical": {
                display: "none",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "var(--th-color)",
              },
              "& .MuiDataGrid-scrollbarFiller--header": {
                backgroundColor: "var(--th-color)",
              },
              "& .MuiDataGrid-scrollbarFiller--borderTop": {
                borderTop: "none",
              },
              "& .MuiDataGrid-scrollbarFiller": {
                display: "none",
              },
              "& .MuiDataGrid-filler": {
                backgroundColor: "var(--th-color)",
                display: "none",
              },
              [`& .MuiDataGrid-row.selected-row`]: {
                backgroundColor: "rgba(25, 118, 210, 0.08) !important",
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.12) !important",
                },
              },
              "& .MuiDataGrid-withBorderColor": {
                borderColor: "var(--dashboard-line-color)",
              },
              "& .MuiDataGrid-cell": {
                borderTop: "1px solid var(--dashboard-line-color)",
              },
              "& .MuiDataGrid-row:last-child .MuiDataGrid-cell": {
                borderBottom: "1px solid var(--dashboard-line-color)",
              },
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: "var(--text-color)",
              },
              "& .MuiTablePagination-root": {
                color: "var(--text-color)",
              },
              "& .MuiSvgIcon-root": {
                color: "var(--text-color)",
              },
              "& .MuiDataGrid-overlayWrapper": {
                minHeight: "30vh",
              },
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "rgba(25, 118, 210, 0.08) !important",
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.12) !important",
                },
              },
              "& .MuiDataGrid-row": {
                backgroundColor: "var(--row-color)",
                color: "var(--text-color)",
              },
            }}
          />
          <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
            <Pagination
              // count={
              //   inspectionType === "AVI"
              //     ? Math.ceil(ngUnitCount.avi_count / unitPageSize)
              //     : Math.ceil(ngUnitCount.ai_count / unitPageSize)
              // }
              // count={Math.ceil(ngUnitCount / unitPageSize)}
              count={totalPage || 0}
              page={unitPage}
              onChange={(event, newPage) => onChangePage(newPage)}
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "var(--text-color)",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "var(--hover-bg-color)",
                },
              }}
            />
          </Box>
        </Box>
      )}
      <UnitInfoModal
        open={openUnitModal}
        onClose={() => {
          setOpenUnitModal(false);
          setSelectedImagePath(null);
          setImage(null);
        }}
        selectedRow={selectedRow}
        selectedUnit={selectedUnit}
        inspectionType={inspectionType}
        selectedImagePath={selectedImagePath}
        setSelectedImagePath={setSelectedImagePath}
        image={image}
        setImage={setImage}
      />
    </Box>
  );
}
